import type { FaireProductEntity } from "../../entity_types/product";

export const plant_dyed_11: FaireProductEntity = {
  token: "plant-dyed-11",
  type: "product",
  name: "Maya Hand Block printed Linen",
  brandName: "Soil to Studio",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/bd1a60b7c414111bbe1a98720fae0500dba6d6491f0d1f1626a1259ba9428ab5.png",
  priceDollars: 5.5,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/bd1a60b7c414111bbe1a98720fae0500dba6d6491f0d1f1626a1259ba9428ab5.png",
  weight: 0.4,
  dimensions: {
    width: 18,
    height: 18,
    depth: 1,
  },
  description: "Maya hand block printed linen with plant dyes",
  categoryTokens: ["cat_accessories"],
  tags: [
    "plant-dyed",
    "natural-dye",
    "sustainable-textiles",
    "linen",
    "hand-block-print",
    "premium",
  ],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
